<template>
  <div>
    <datatable
      title="Stats"
      @thFilter="thFilter"
      @create="createStat"
      @done="done"
      @edit_click="editClick"
      :operations="operations"
      :filters="filters"
      :fields="fields"
      :response="data"
      :working_th_searches="working_th_searches"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-alerts',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      filters_helper: filters_helper,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'full_name',
          component_data_path: 'resources.applicant',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Applicant'
          }
        },
        {
          name: 'company_name',
          component_data_path: 'resources.company',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Company'
          }
        },
        {
          name: 'position_title',
          component_data_path: 'resources.position',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Position'
          }
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'content',
          value: 'content'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'applicant_last_login',
          value: 'resources.applicant.last_login',
          is_time: true
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        }
      ],
      filters: [
        {
          type: 'single',
          designator: 'statuses',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'done',
              value: 'done'
            },
            {
              text: 'awaiting_manager',
              value: 'awaiting_manager'
            },
            {
              text: 'blocked',
              value: 'blocked'
            }
          ]
        },
        {
          type: 'single',
          designator: 'owner',
          options: filters_helper.getOwnerFilterOptions()
        }
      ],
      th_filters: [],
      data: [],
      operations: [{ name: 'Done' }],
      working_th_searches: ['id', 'owner', 'company_name', 'position_title', 'owner']
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getStats()
    },
    getStats () {
      let current_date = new Date()
      let yesterday_date = new Date()
      yesterday_date.setDate(current_date.getDate() - 1)
      yesterday_date = this.getStatFormatDate(yesterday_date)
      current_date = this.getStatFormatDate(current_date)
      let data = {
        page: this.$route.query.page || 1,
        per: 100,
        date_from: yesterday_date,
        date_to: current_date,
        ...this.filters_helper.getServerCallFilters(this.filters),
        ...this.th_filters
      }
      this.$network_utils.getStats(data).then(response => {
        this.data = response
      })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getStats()
    },
    getStatFormatDate (date) {
      let time =
        date.getUTCHours() +
        ':' +
        date.getUTCMinutes() +
        ':' +
        date.getUTCSeconds()
      let full_date =
        date.getUTCDate() +
        '-' +
        (date.getUTCMonth() + 1) +
        '-' +
        date.getUTCFullYear()
      return full_date + ' ' + time
    },
    done (data) {
      this.$network_utils.postDoneAlert(data, 'done')
    },
    createStat () {
      this.create({ designator: 'stat-form-modal', component_name: 'StatForm', is_create: true, modal_title: 'Create new Stat' })
    },
    editClick (data) {
      this.create({ designator: 'stat-form-modal', component_name: 'StatForm', data, modal_title: 'Edit Stat' })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
